//
// Module for the DROP Enrollment wizard's Initiate step
//
rs.module("participant/benefit/setup/drop/wizard/initiatestep",

    [ "common/select-helper", "controls/components/event-banner" ],

    function (selectHelper, eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            // Get the wizard's next button
            var wizardNextButton = $(`[data-wizard]`).js("_next");

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var dropEntryDateInput = stepContainer.js(jsSelectors.dropEntryDateInput, { required: false });
            var dropPlanSelect = stepContainer.js(jsSelectors.dropPlanSelect);
            var dropPlanSelectHelper = selectHelper.getHelper(dropPlanSelect);
            var applyIncomeLevelingCheckBox = stepContainer.js(jsSelectors.applyIncomeLevelingCheckBox, { required: false });
            var socialSecurityBenefitAmountInput = stepContainer.js(jsSelectors.socialSecurityBenefitAmountInput, { required: false });
            var socialSecurityStartAgeInput = stepContainer.js(jsSelectors.socialSecurityStartAgeInput, { required: false });
            var socialSecurityEvidenceFiledCheckbox = stepContainer.js(jsSelectors.socialSecurityEvidenceFiledCheckbox, { required: false });          
            var initiateOnlyCheckBox = stepContainer.js(jsSelectors.initiateOnlyCheckBox, { required: false });

            // On initialize of page, appropriately set wizard's next button text (Next or Finish)
            setWizardNextButtonText();

            // Conditionally set display of Wizard's next button text (Next or Finish) based on InitiateOnlyCheckBox
            function setWizardNextButtonText() {

                // Get the Next button's HTML (contains text and spinner icon)
                var buttonHtml = wizardNextButton.html();

                // Conditionally update text portion of button's HTML based on initiateOnlyCheckBox
                if (initiateOnlyCheckBox.is(":checked")) {
                    wizardNextButton.html(buttonHtml.replace('Next', 'Finish'));
                }
                else {
                    wizardNextButton.html(buttonHtml.replace('Finish', 'Next'));
                }
            }

            // Hookup dropEntryDateInput change event
            dropEntryDateInput.change(_.debounce(function () { dropEntryDateChange(); }, 500));

            // Enable/Disable Income Leveling fields on applyIncomeLevelingCheckBox change
            applyIncomeLevelingCheckBox.change(function () {

                // Enable/disable Income Leveling fields
                socialSecurityBenefitAmountInput.prop("disabled", !this.checked).val("").clearErrors();
                socialSecurityStartAgeInput.prop("disabled", !this.checked).val("").clearErrors();
                socialSecurityEvidenceFiledCheckbox.prop("disabled", !this.checked).prop('checked', false);
            });

            // Handle initiateOnlyCheckBox change
            initiateOnlyCheckBox.change(function () {

                // Set wizard's next button text (Next or Finish)
                setWizardNextButtonText();
            });

            // DROP Entry Date change event
            function dropEntryDateChange() {

                // Populate applicable Drop Plans 
                populateDropPlans();
            }

            // Populate applicable DROP Plans
            function populateDropPlans() {

                if (dropEntryDateInput.val() && dropEntryDateInput.valid()) {

                    eventBanner.removeAllMessages();

                    dropPlanSelectHelper.loadOptionsFrom(
                        backendUrls.getApplicableDropPlans,
                        {
                            effectiveAsOfDate: dropEntryDateInput.val()
                        },
                        {
                            withBlank: true
                        });  
                }
                else {
                    dropPlanSelectHelper.clearOptions();
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);